module.exports = __webpack_public_path__ + "img/wait-icon.36cd1ac0.svg";